import { render } from "./MenuResultats.vue?vue&type=template&id=e5b30bfa"
import script from "./MenuResultats.vue?vue&type=script&lang=js"
export * from "./MenuResultats.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__